/* Stonvale Restock Sale page: countdown, header hide-on-scroll, hero video, sort / filter / show more. */
(function () {
  'use strict';
  var d = document, w = window;
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* ---------- countdown (announcement bar) ---------- */
  function initCountdown() {
    var els = $$('.rs-bar__count'); if (!els.length) return;
    var bar = $('.rs-bar');
    var raw = (bar && bar.getAttribute('data-end')) || '';
    var fixed = raw ? new Date(raw).getTime() : NaN;
    var hasFixed = !isNaN(fixed);
    function tick() {
      var now = new Date(), target;
      if (hasFixed) target = fixed;
      else target = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0).getTime(); /* viewer's next local midnight (same as Okura) */
      var rem = Math.max(0, Math.floor((target - Date.now()) / 1000));
      if (hasFixed && rem <= 0) { if (bar) bar.classList.add('rs-bar--ended'); }
      var days = Math.floor(rem / 86400), h = Math.floor((rem % 86400) / 3600), m = Math.floor((rem % 3600) / 60), s = rem % 60;
      var txt = hasFixed && days > 0 ? days + 'd ' + pad(h) + ':' + pad(m) + ':' + pad(s) : pad(days * 24 + h) + ':' + pad(m) + ':' + pad(s);
      els.forEach(function (e) { e.textContent = txt; });
    }
    tick(); setInterval(tick, 1000);
  }

  /* ---------- header: hide on scroll down, show on scroll up ---------- */
  function initHeader() {
    var hg = d.getElementById('header-group'); if (!hg || !$('.rs-bar', hg)) return;
    /* this theme scrolls inside .page-wrapper on desktop (window on phones) */
    var sc = $('.page-wrapper');
    function sy() { return Math.max(w.scrollY || 0, sc ? sc.scrollTop : 0); }
    var last = sy(), ticking = false;
    function locked() { return d.documentElement.classList.contains('rs-lock') || !!$('.hd.open'); }
    function hide() { hg.style.setProperty('--rs-hdr-top', (-(hg.offsetHeight + 4)) + 'px'); }
    function show() { hg.style.removeProperty('--rs-hdr-top'); }
    function run() {
      ticking = false;
      var y = sy(), dy = y - last;
      if (locked()) { last = y; return; }
      if (y <= 0) { show(); last = y; return; }
      if (Math.abs(dy) < 5) return;
      if (dy > 0 && y > 120) hide(); else if (dy < 0) show();
      last = y;
    }
    var onScroll = function () { if (!ticking) { ticking = true; w.requestAnimationFrame(run); } };
    w.addEventListener('scroll', onScroll, { passive: true });
    if (sc) sc.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- hero video (desktop + phone, like Okura): poster <img> is already painted; the video is attached after load so it never competes with the LCP image, fades in once playing ---------- */
  function initVideo() {
    var box = $('[data-rs-video]'); if (!box) return;
    if (w.matchMedia('(prefers-reduced-motion:reduce)').matches || (navigator.connection && navigator.connection.saveData)) return;
    var phone = w.matchMedia('(max-width:749px)').matches;
    var src = (phone && box.getAttribute('data-src-m')) || box.getAttribute('data-src'); if (!src) return;
    function start() {
      if (box.querySelector('video')) return;
      var v = d.createElement('video');
      v.muted = true; v.defaultMuted = true; v.loop = true; v.autoplay = true; v.playsInline = true; v.preload = 'auto';
      v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('aria-hidden', 'true'); v.tabIndex = -1;
      v.addEventListener('playing', function () { v.classList.add('is-on'); });
      v.src = src;
      box.appendChild(v);
      var p = v.play(); if (p && p.catch) p.catch(function () { });
    }
    if (d.readyState === 'complete') start(); else w.addEventListener('load', start, { once: true });
  }

  /* ---------- collection: sort, filter, show more ---------- */
  function initGrid() {
    var root = $('[data-rs-grid]'); if (!root) return;
    root.classList.remove('rs-nojs');
    var grid = $('.rs-grid', root);
    var cells = $$('.rs-cell', grid);
    var total = cells.length;
    var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 24;
    var shown = perPage;
    var sortKey = 'manual', bestRank = null;
    var f = { avail: null, min: 0, max: 0, cat: 'all' };
    var catMap = {}; try { var mapEl = $('[data-rs2-map]', root); if (mapEl) catMap = JSON.parse(mapEl.textContent); } catch (e) { }
    var priceMax = 0;
    cells.forEach(function (c, i) {
      c._i = i; c._p = parseInt(c.getAttribute('data-price'), 10) / 100; c._a = c.getAttribute('data-avail') === '1';
      c._t = (c.getAttribute('data-title') || '').toLowerCase(); c._c = parseInt(c.getAttribute('data-created'), 10) || 0; c._h = c.getAttribute('data-handle');
      c._k = c.getAttribute('data-svcat') || catMap[c._h] || 'others'; c.setAttribute('data-svcat', c._k);
      if (c._p > priceMax) priceMax = c._p;
    });
    priceMax = Math.ceil(priceMax); f.max = priceMax;

    var countEl = $('[data-rs-count]', root), moreBox = $('[data-rs-more]', root), moreBtn = $('[data-rs-morebtn]', root);
    var moreLabel = $('[data-rs-morelabel]', root), moreBar = $('[data-rs-morebar]', root), emptyEl = $('[data-rs-empty]', root);
    var showItems = $('[data-rs-showitems]', root), clearBtn = $('[data-rs-clear]', root), fbtn = $('[data-rs-fopen]', root);

    function filtered() {
      return cells.filter(function (c) {
        if (f.avail === true && !c._a) return false;
        if (f.avail === false && c._a) return false;
        if (f.cat !== 'all' && c._k !== f.cat) return false;
        if (c._p < f.min || c._p > f.max) return false;
        return true;
      });
    }
    function sorted(list) {
      var a = list.slice();
      var by = {
        'manual': function (x, y) { return x._i - y._i; },
        'relevant': function (x, y) { return x._i - y._i; },
        'best': function (x, y) { var rx = bestRank && bestRank[x._h] != null ? bestRank[x._h] : 9999 + x._i, ry = bestRank && bestRank[y._h] != null ? bestRank[y._h] : 9999 + y._i; return rx - ry; },
        'az': function (x, y) { return x._t.localeCompare(y._t); },
        'za': function (x, y) { return y._t.localeCompare(x._t); },
        'plh': function (x, y) { return x._p - y._p || x._i - y._i; },
        'phl': function (x, y) { return y._p - x._p || x._i - y._i; },
        'old': function (x, y) { return x._c - y._c; },
        'new': function (x, y) { return y._c - x._c; }
      };
      return a.sort(by[sortKey] || by.manual);
    }
    function isFiltered() { return f.avail !== null || f.min > 0 || f.max < priceMax; }
    function render(animateFrom) {
      var list = sorted(filtered());
      var keep = {};
      list.forEach(function (c, i) { keep[c._i] = 1; });
      /* reorder DOM only when sort changed */
      var frag = d.createDocumentFragment();
      sorted(cells).forEach(function (c) { frag.appendChild(c); });
      grid.appendChild(frag);
      cells.forEach(function (c) { c.classList.toggle('is-off', !keep[c._i]); c.classList.remove('is-more'); });
      list.forEach(function (c, i) {
        if (i >= shown) c.classList.add('is-more');
        else if (animateFrom != null && i >= animateFrom) { c.classList.remove('is-new'); void c.offsetWidth; c.classList.add('is-new'); }
      });
      var n = list.length, vis = Math.min(shown, n);
      if (countEl) countEl.textContent = countEl.getAttribute('data-tpl').replace('{n}', n);
      if (moreBox) {
        moreBox.hidden = n <= perPage;
        if (moreLabel) moreLabel.textContent = moreLabel.getAttribute('data-tpl').replace('{a}', vis).replace('{b}', n);
        if (moreBar) moreBar.style.width = (n ? Math.round(vis / n * 100) : 0) + '%';
        if (moreBtn) moreBtn.hidden = vis >= n;
      }
      if (emptyEl) emptyEl.hidden = n > 0;
      if (showItems) showItems.querySelector('span').textContent = '(' + n + ')';
      var act = isFiltered();
      if (clearBtn) clearBtn.disabled = !act;
      if (fbtn) fbtn.classList.toggle('has-active', act);
    }

    /* show more */
    if (moreBtn) moreBtn.addEventListener('click', function () { var from = shown; shown += perPage; render(from); });

    /* sort dropdown */
    var sortBox = $('[data-rs-sort]', root);
    if (sortBox) {
      var sbtn = $('.rs-sort__btn', sortBox), opts = $$('.rs-sort__opt', sortBox), cur = $('[data-rs-sortcur]', sortBox);
      var open = function (o) { sortBox.classList.toggle('is-open', o); sbtn.setAttribute('aria-expanded', o ? 'true' : 'false'); if (o) { var s = $('[aria-selected="true"]', sortBox); if (s) s.focus({ preventScroll: true }); } };
      sbtn.addEventListener('click', function (e) { e.stopPropagation(); open(!sortBox.classList.contains('is-open')); });
      d.addEventListener('click', function (e) { if (!sortBox.contains(e.target)) open(false); });
      d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sortBox.classList.contains('is-open')) { open(false); sbtn.focus(); } });
      var pick = function (o) {
        opts.forEach(function (x) { x.setAttribute('aria-selected', x === o ? 'true' : 'false'); });
        cur.textContent = o.getAttribute('data-label'); sortKey = o.getAttribute('data-sort'); open(false);
        var go = function () { shown = perPage; render(); };
        if (sortKey === 'best' && !bestRank) {
          fetchBest().then(go, go);
        } else go();
      };
      opts.forEach(function (o, i) {
        o.addEventListener('click', function () { pick(o); });
        o.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(o); }
          else if (e.key === 'ArrowDown') { e.preventDefault(); (opts[i + 1] || opts[0]).focus(); }
          else if (e.key === 'ArrowUp') { e.preventDefault(); (opts[i - 1] || opts[opts.length - 1]).focus(); }
        });
      });
    }
    function fetchBest() {
      var u = new URL(w.location.href); u.searchParams.set('sort_by', 'best-selling');
      return fetch(u.toString(), { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (t) {
        var doc = new DOMParser().parseFromString(t, 'text/html'), rank = {}, k = 0;
        $$('[data-rs-grid] .rs-cell', doc).forEach(function (c) { rank[c.getAttribute('data-handle')] = k++; });
        bestRank = rank;
      });
    }

    /* filter panel */
    var panel = $('[data-rs-filter]'); /* panel lives inside root */
    if (panel) {
      var openers = $$('[data-rs-fopen]', root), closers = $$('[data-rs-fclose]', panel), lastFocus = null;
      var setOpen = function (o) {
        panel.classList.toggle('is-open', o); d.documentElement.classList.toggle('rs-lock', o);
        var pw = $('.page-wrapper'); if (pw) pw.style.overflowY = o ? 'hidden' : '';
        openers.forEach(function (b) { b.setAttribute('aria-expanded', o ? 'true' : 'false'); });
        if (o) { lastFocus = d.activeElement; var x = $('.rs-filter__x', panel); if (x) setTimeout(function () { x.focus({ preventScroll: true }); }, 50); }
        else if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      };
      openers.forEach(function (b) { b.addEventListener('click', function () { setOpen(true); }); });
      closers.forEach(function (b) { b.addEventListener('click', function () { setOpen(false); }); });
      d.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && panel.classList.contains('is-open')) setOpen(false);
        if (e.key === 'Tab' && panel.classList.contains('is-open')) {
          var f2 = $$('button:not([disabled]),input,[tabindex]:not([tabindex="-1"])', panel).filter(function (x) { return x.offsetParent !== null; });
          if (!f2.length) return; var a = f2[0], z = f2[f2.length - 1];
          if (e.shiftKey && d.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && d.activeElement === z) { e.preventDefault(); a.focus(); }
        }
      });
      /* group collapse (mobile) */
      $$('.rs-group__h', panel).forEach(function (h) { h.addEventListener('click', function () { var g = h.parentNode; var c = g.classList.toggle('is-closed'); h.setAttribute('aria-expanded', c ? 'false' : 'true'); }); });
      /* availability */
      var chipIn = $('[data-rs-avail="in"]', panel), chipOut = $('[data-rs-avail="out"]', panel);
      var anyOut = cells.some(function (c) { return !c._a; }), anyIn = cells.some(function (c) { return c._a; });
      if (chipOut && !anyOut) chipOut.disabled = true;
      if (chipIn && !anyIn) chipIn.disabled = true;
      function setAvail(v) {
        f.avail = f.avail === v ? null : v;
        if (chipIn) chipIn.setAttribute('aria-pressed', f.avail === true ? 'true' : 'false');
        if (chipOut) chipOut.setAttribute('aria-pressed', f.avail === false ? 'true' : 'false');
        shown = perPage; render();
      }
      if (chipIn) chipIn.addEventListener('click', function () { setAvail(true); });
      if (chipOut) chipOut.addEventListener('click', function () { setAvail(false); });
      /* price */
      var rmin = $('[data-rs-rmin]', panel), rmax = $('[data-rs-rmax]', panel), nmin = $('[data-rs-nmin]', panel), nmax = $('[data-rs-nmax]', panel), fill = $('.rs-range__fill', panel);
      [rmin, rmax].forEach(function (r) { r.min = 0; r.max = priceMax; r.step = 1; });
      rmin.value = 0; rmax.value = priceMax; nmin.value = 0; nmax.value = priceMax;
      function paint() { var a = (f.min / priceMax) * 100, b = (f.max / priceMax) * 100; fill.style.left = a + '%'; fill.style.width = Math.max(0, b - a) + '%'; }
      function apply(src) {
        var lo = parseFloat(src === 'nmin' ? nmin.value : rmin.value), hi = parseFloat(src === 'nmax' ? nmax.value : rmax.value);
        if (isNaN(lo)) lo = 0; if (isNaN(hi)) hi = priceMax;
        lo = Math.max(0, Math.min(lo, priceMax)); hi = Math.max(0, Math.min(hi, priceMax));
        if (lo > hi) { if (src === 'rmax' || src === 'nmax') lo = hi; else hi = lo; }
        f.min = lo; f.max = hi; rmin.value = lo; rmax.value = hi; nmin.value = lo; nmax.value = hi; paint(); shown = perPage; render();
      }
      rmin.addEventListener('input', function () { apply('rmin'); }); rmax.addEventListener('input', function () { apply('rmax'); });
      nmin.addEventListener('change', function () { apply('nmin'); }); nmax.addEventListener('change', function () { apply('nmax'); });
      paint();
      function clearAll() {
        f.avail = null; f.min = 0; f.max = priceMax;
        if (chipIn) chipIn.setAttribute('aria-pressed', 'false'); if (chipOut) chipOut.setAttribute('aria-pressed', 'false');
        rmin.value = 0; rmax.value = priceMax; nmin.value = 0; nmax.value = priceMax; paint(); shown = perPage; render();
      }
      if (clearBtn) clearBtn.addEventListener('click', clearAll);
      var emptyClear = $('[data-rs-emptyclear]', root); if (emptyClear) emptyClear.addEventListener('click', clearAll);
      if (showItems) showItems.addEventListener('click', function () { setOpen(false); });
    }

    /* category pills (filter in place, no URL change; counts = all cards incl. those behind Show more; empty categories hidden) */
    var pills = $$('[data-rs2-cats] [data-cat]', d);
    if (pills.length) {
      f.cat = 'all'; pills.forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-cat') === 'all' ? 'true' : 'false'); }); var prow = $('.rs2-cats-row', d); if (prow) prow.scrollLeft = 0;
      var counts = { all: cells.length };
      cells.forEach(function (c) { counts[c._k] = (counts[c._k] || 0) + 1; });
      pills.forEach(function (b) {
        var k = b.getAttribute('data-cat'), n = counts[k] || 0, ne = $('[data-n]', b);
        if (ne) ne.textContent = n; b.hidden = k !== 'all' && n === 0;
        b.addEventListener('click', function () {
          f.cat = k;
          pills.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          shown = k === 'all' ? perPage : total; /* a category shows ALL its matching cards, even ones behind Show more */
          render();
        });
      });
    }

    /* not shippable: every product unavailable in this country */
    var note = $('[data-rs-note]', root);
    if (note && total && !cells.some(function (c) { return c._a; })) note.hidden = false;

    render();
  }

  function boot() { initCountdown(); initHeader(); initVideo(); initGrid(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();
